<template>
    <v-form ref="form">
        <v-row>
            <v-col>
                <v-text-field
                    :label="$t('name')"
                    outlined
                    dense
                    :value="name"
                    @input="$emit('update:name', $event)"
                    hide-details="auto"
                    :rules=[isRequired]>
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    :label="$t('phone')"
                    outlined
                    dense
                    :value="phone"
                    @input="$emit('update:phone', $event)"
                    hide-details="auto">
                </v-text-field>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { isRequired } from './../../utils/validations';

export default {
    props: {
        name: String,
        phone: String
    },
    data() {
        return{}
    },
    methods: {
        isRequired,
        validate() {
            return this.$refs.form.validate();
        }
    },
    watch:{},
}
</script>

<style>

</style>